import React, { useState } from 'react';
import { Button, Upload, notification } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';

const ImportLeadVisits = (props) => {
  const [file, setFile] = useState(null);

  const clearUpload = () => {
    setFile(null);
    return true;
  };

  const beforeUpload = (selectedFile) => {
    setFile(selectedFile);
    return false;
  };

  const sendData = () => {
    const { projectId } = props.match.params;
    const data = file;
    const formData = new FormData();
    formData.append('import_file', data);
    props.dispatch({
      type: 'leads/startImportCompanyAttributesLeadLabels',
      payload: {
        projectId,
        data: formData,
      },
    }).then(response => response && response.success && clearUpload() && notification.success({
      message: props.intl.formatMessage({ id: 'Common.Success' }),
    }));
  };

  const renderUpload = () => {
    return (
      <Upload
        accept=".xlsx, .xls"
        showUploadList={false}
        beforeUpload={selectedFile => beforeUpload(selectedFile)}
      >
        <Button
          size="large"
          type="primary"
          icon={'upload'}
        >
          <FormattedMessage id="Common.SelectFile" />
        </Button>
      </Upload>
    );
  };

  const renderSubmitBtn = () => {
    return (
      <React.Fragment>
        <Button
          size="large"
          type="primary"
          onClick={sendData.bind(this)}
        >
          {props.intl.formatMessage({ id: 'Common.NewImport' }, { fileName: file.name })}
        </Button>
        <Button
          icon={'close'}
          size="large"
          type="primary"
          onClick={clearUpload.bind(this)}
        />
      </React.Fragment>
    );
  };

  return !file ? renderUpload() : renderSubmitBtn();
};

export default withRouter(connect(({ leads }) => ({ leads }))(injectIntl(ImportLeadVisits)));



// WEBPACK FOOTER //
// ./src/components/ImportFile/ImportFile.js